import React from 'react';
import { Fab, Tooltip, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppButton = () => {
  const phoneNumber = '573158497136'; 
  const message = encodeURIComponent("¡Hola! 👋 Me interesa conocer más sobre cómo Effsos puede ayudarme a digitalizar y mejorar mi negocio.🚀¿Me podrías dar más información?.");
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <Tooltip title="Escríbenos por WhatsApp" placement="left" TransitionComponent={Zoom}>
      <Fab
        color="success"
        aria-label="whatsapp"
        onClick={() => window.open(whatsappLink, '_blank')}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1500,
          boxShadow: 4,
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.1)',
          },
        }}
      >
        <WhatsAppIcon fontSize="large" />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;
